module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Risk",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M37.5589228,6.47068661 L64.4527606,50.4345032 C65.3173606,51.8478796 64.8724894,53.6945444 63.459113,54.5591444 C62.9878288,54.8474415 62.4460871,55 61.8936162,55 L8.10594075,55 L8.10594075,55 C6.4490865,55 5.10594075,53.6568542 5.10594075,52 C5.10594075,51.4475292 5.25849929,50.9057874 5.5467964,50.4345032 L32.4406341,6.47068661 L32.4406341,6.47068661 C33.3052341,5.05731021 35.1518989,4.61243903 36.5652753,5.47703903 C36.9704865,5.72491755 37.3110443,6.06547535 37.5589228,6.47068661 L37.5589228,6.47068661 Z M33.9157,39.1018676 L37.0507101,39.1018676 L38.8873826,26.385078 L38.8873826,23.5919847 L32.0473606,23.5919847 L32.0473606,26.385078 L33.9157,39.1018676 Z M32.3640283,46.5939296 L38.6023817,46.5939296 L38.6023817,41.007743 L32.3640283,41.007743 L32.3640283,46.5939296 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-461e2e92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/risk.vue
// module id = 618
// module chunks = 1